import { trackProspectTrialEvent } from "util/productAnalytics";

const STORAGE_KEY = "pivony_prospect_trial_analytics_v1";

function readSentMap() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}

function writeSentMap(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore quota errors */
  }
}

function trackProspectTrialOnce(eventName, properties = {}) {
  const key = String(eventName || "").trim();
  if (!key) return false;
  const sent = readSentMap();
  if (sent[key]) return false;
  sent[key] = Date.now();
  writeSentMap(sent);
  trackProspectTrialEvent(key, properties);
  return true;
}

export function trackProspectProductMilestone(eventName, properties = {}) {
  trackProspectTrialOnce(eventName, properties);
}
